export default "/assets/Icon/mastercard.svg"